var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowUp = function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.933 4.248v30.685",
    stroke: "var(--a, #000)",
    strokeWidth: 3.62
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 19 17.856 3.143 33.712 19",
    stroke: "var(--a, #000)",
    strokeWidth: 3.5
  })));
};

export default SvgArrowUp;